module.exports = __webpack_public_path__ + "img/machinegun.b3e9ca82.png";